import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { Button, Typography } from "@mui/material";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FunctionField, List, TextInput, useRecordContext, WrapperField } from "react-admin";
import { AdminDateTime } from "@/components/AdminDateTime";
import { useTranslation } from "react-i18next";
import { ListActions } from "@/components/ListActions";
import { ActionsColumn } from "@/components/ActionButons";
import { DataGridContainerStyle } from "../ScheduledEvents/ListScheduledEvent";
import { useTenantStore } from "@/providers/TenantContextProvider";
var Notifications = function (_a) {
    var electionEventId = _a.electionEventId;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var t = useTranslation().t;
    var record = useRecordContext();
    var tenantId = useTenantStore()[0];
    var Filters = [
        _jsx(TextInput, { source: "election" }, "Election"),
        _jsx(TextInput, { source: "event_type" }, "Event Type"),
        _jsx(TextInput, { source: "schedule" }, "Schedule"),
    ];
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, { variant: "h4", paragraph: true, children: t("eventsScreen.empty.header") }), _jsx(Typography, { variant: "body1", paragraph: true, children: t("eventsScreen.empty.body") }), _jsx(ResourceListStyles.EmptyButtonList, { className: "voter-add-button", children: _jsxs(Button, { onClick: function () { return console.log("test"); }, children: [_jsx(ResourceListStyles.CreateIcon, { icon: faPlus }), t("eventsScreen.empty.button")] }) })] })); };
    var actions = [
    // {
    //     icon: <EditIcon className="edit-voter-icon" />,
    //     action: (id) => editAction(id),
    //     showAction: () => canEdit,
    // },
    // {
    //     icon: <DeleteIcon className="delete-voter-icon" />,
    //     action: (id) => deleteAction(id),
    //     showAction: () => canCreate,
    //     label: t(`common.label.delete`),
    //     className: "delete-voter-icon",
    // },
    ];
    var filterObject = {
        election_event_id: (record === null || record === void 0 ? void 0 : record.id) || undefined,
        tenant_id: tenantId,
    };
    return (_jsxs(_Fragment, { children: [_jsx(List, { resource: "sequent_backend_notification", queryOptions: {
                    refetchInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
                }, empty: _jsx(Empty, {}), actions: _jsx(ListActions, { withImport: true, 
                    // doImport={handleImport}
                    withExport: true }), filter: filterObject, filters: Filters, children: _jsxs(DataGridContainerStyle
                // bulkActionButtons={<BulkActions />}
                // isOpenSideBar={isOpenSidebar}
                // omit={OMIT_FIELDS}
                , { children: [_jsx(FunctionField, { label: "Created at", source: "created_at", render: function (record) { return (_jsx(AdminDateTime, { value: record.created_at, event: record.election_event_id, seconds: true })); } }), _jsx(WrapperField, { label: "Actions", children: _jsx(ActionsColumn, { actions: actions }) })] }) }), _jsx(ResourceListStyles.Drawer, { anchor: "right" })] }));
};
export default Notifications;
